import { NavigationProp, ParamListBase, StackActions } from '@react-navigation/native';

export const popToRipsGameWebView = (navigation: Pick<NavigationProp<ParamListBase>, 'dispatch'>) => {
    // merge keeps the webview's existing params (url)
    navigation.dispatch(StackActions.popTo('RipsGameWebView', undefined, { merge: true }));
};
